<template>
  <div class="form-group" v-if="!layoutItem">
    <label class="custom-label">{{labelDesc}}</label>
    <div class="form">
      <label style="width: 250px;">
        <input type="checkbox" v-model="anchorActive" @change="changeValue" @keyup="changeValue">
        {{ $t('ct-active') }}
      </label>
      <label v-show="anchorActive===true">
        {{ $t('ct-name') }}
        <input type="text" class="custom-input form-control" ref="inputAnchorName" @input="isTyping = true" v-model="anchorName"
               @change="changeValue" @keyup="changeValue">
      </label>
    </div>
  </div>
</template>
<script>
export default {
  name: 'AnchorComponent',
  data() {
    return {
      element: null,
      anchorActive: false,
      anchorName: '',
      labelDesc: 'opa',
      callback: null,
      layoutItem: false,
      isTyping: false
    };
  },

  watch: {
    isTyping: function(value) {
      if (!value) {
        this.changeValue();
      }
    }
  },

  methods: {
    changeValue() {
      this.anchorName = this.anchorName.replace(/\s/g, '');

      let obj = {
        anchorActive: this.anchorActive,
        anchorName: this.anchorName
      };

      this.callback(obj);
    },
    setValues(obj) {
      this.anchorActive = obj.anchorActive;
      this.anchorName = obj.anchorName;
      this.element = obj.element;
      this.labelDesc = this.$t(`ct-${obj.labelDesc}`);
      this.callback = obj.callback;

      if (this.$route.name === 'editor-layout-item') { this.layoutItem = true }

      if (this.$refs.inputAnchorName) {
        let vm = this;
        this.$refs.inputAnchorName.addEventListener('keyup', this.$debounce(() => {
          vm.isTyping = false;
        }, 500));
      }
    }
  }
};
</script>
<style scoped lang="scss">
  .form-group {
    overflow: hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/editor/resource_components/Anchor.vue